import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';

export interface SectorOption {
  label: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class SectorService {
  private http = inject(HttpClient);
  private readonly url = 'assets/data/sectors.json';

  private sectors$ = this.http
    .get<Record<string, string>>(this.url)
    .pipe(shareReplay(1));

  getSectors(): Observable<SectorOption[]> {
    return this.sectors$.pipe(
      map(sectors => {
        return Object.entries(sectors).map(([key, value]) => ({
          label: value,
          value: key
        }));
      })
    );
  }

  getSectorNameByCode(code: string): Observable<string | null> {
    return this.sectors$.pipe(
      map(sectors => sectors[code] ?? null)
    );
  }
}
